
import { ProduktLangdfordelningDTO } from "~app/common/models/produkt/ProduktLangdfordelningDTO";

export class ProduktDiameterfordelningDTO   {

    id: number;
    typ: string;
    diamBotten: number;
    produktLangdfordelningar: ProduktLangdfordelningDTO[];

    constructor() {
        this.id = undefined;
        this.typ = undefined;
        this.diamBotten = undefined;
        this.produktLangdfordelningar = undefined;
    }
}
